<template>
  <div>
    <a-collapse
      :bordered="true"
      expand-icon-position="right"
      :activeKey="['1', '2', '3', '4']"
      class="detail-collapse"
    >
      <!-- ===================== 房源基本信息 ===================== -->
      <a-collapse-panel key="1">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              style="font-size: 16px; margin-bottom: 0px"
            >
              房源基本信息
            </div>
          </a-space>
        </template>
        <a-form-model class="basic" :model="form" :rules="rules" ref="baseForm">
          <a-row :gutter="24">
            <a-col :span="24">
              <a-form-model-item label="房源名称" prop="systemNo">
                <a-input v-model="form.systemNo" />
              </a-form-model-item>
            </a-col>

            <!-- 字典 -->
            <a-col :span="24">
              <a-form-model-item
                label="房源所在省/市/区(县)"
                prop="certificateNo"
              >
                <a-input v-model="form.certificateNo" />
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-form-model-item label="详细地址" prop="address">
                <a-input v-model="form.address" />
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-collapse-panel>

      <!-- ===================== 资产信息 ===================== -->
      <a-collapse-panel key="2">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              style="font-size: 16px; margin-bottom: 0px"
            >
              资产信息
            </div>
          </a-space>
        </template>
        <a-table
          :columns="fileColumns"
          :data-source="form.fileList"
          :pagination="false"
          rowKey="id"
        >
          <template slot="file" slot-scope="text, record">
            <a :href="record.url" target="_blank">{{ record.name }}</a>
          </template>

          <template slot="action"> -- </template>
        </a-table>
      </a-collapse-panel>

      <!-- ===================== 房源属性信息 ===================== -->
      <a-collapse-panel key="3">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              style="font-size: 16px; margin-bottom: 0px"
            >
              房源属性信息
            </div>
          </a-space>
        </template>
        <a-form-model class="obligee" :model="form" layout="vertical">
          <a-row :gutter="24">
            <a-col :span="24">
              <div
                style="
                  width: 50%;
                  margin: auto; /* 完整水平居中 */
                  line-height: 26px;
                "
              >
                <a-form-model-item
                  label="房屋状态"
                  :label-col="{ span: 24 }"
                  :wrapper-col="{ span: 24 }"
                >
                  <div style="padding-left: 30px; /* 缩进，让内容视觉居中 */">
                    <a-radio-group v-model="form.sameAddress">
                      <a-radio style="margin: 4px 0px" :value="1"
                        >本标的房屋租赁合同已到期，房屋尚在使用中，若招租后发生移交纠纷，由出租方负责解决</a-radio
                      >
                      <br />
                      <a-radio style="margin: 4px 0px" :value="2"
                        >本标的房屋尚在租赁合同期内，到期后由出租方负责落实资产交付相关事项</a-radio
                      >
                      <br />
                      <a-radio style="margin: 4px 0px" :value="3"
                        >本标的房屋物业状态为空置</a-radio
                      >
                      <br />
                      <a-radio style="margin: 4px 0px" :value="4"
                        >其他
                        <a-input
                          v-if="form.sameAddress === 4"
                          :style="{ width: 100, marginLeft: 10 }"
                      /></a-radio>
                    </a-radio-group>
                  </div>
                </a-form-model-item>
              </div>
            </a-col>

            <a-col :span="12">
              <a-form-model-item label="租赁面积" prop="address">
                <a-input v-model="form.address" />
              </a-form-model-item>
            </a-col>
            <a-col :span="12" v-if="form.sameAddress === 2">
              <a-form-model-item label="租赁期限届满时间" prop="address">
                <a-input v-model="form.address" />
              </a-form-model-item>
            </a-col>

            <a-col :span="24">
              <a-form-model-item label="租赁用途" prop="sameAddress">
                <a-checkbox-group v-model="form.board" style="width: 100%">
                  <a-row :gutter="[0, 12]">
                    <a-col :span="3" v-for="item in boardList" :key="item">
                      <a-checkbox :value="item">{{ item }}</a-checkbox>
                    </a-col>
                  </a-row>
                </a-checkbox-group>
              </a-form-model-item>
            </a-col>
          </a-row>
        </a-form-model>
      </a-collapse-panel>

      <!-- ===================== 上传附件 ===================== -->
      <a-collapse-panel key="4">
        <template v-slot:header>
          <a-space align="center">
            <div class="title_icon"></div>
            <div
              style="font-size: 16px; margin-bottom: 0px"
            >
              上传附件
            </div>
          </a-space>
        </template>
        <a-table
          :columns="fileColumns"
          :data-source="form.fileList"
          :pagination="false"
          rowKey="id"
        >
          <template slot="file" slot-scope="text, record">
            <a :href="record.url" target="_blank">{{ record.name }}</a>
          </template>

          <template slot="action"> -- </template>
        </a-table>
      </a-collapse-panel>
    </a-collapse>
  </div>
</template>

<script>
export default {
  data() {
    return {
      form: {
        systemNo: "",
        certificateNo: "",
        type: "1",
        area: "",
        address: "",
        sameAddress: true,
        realAddress: "1",
        realAddressDetail: "",
        usage: "",

        rightIsAgency: false,
        rightName: "",
        rightCode: "",
        rightIsState: false,
        rightGroup: "",
        rightType: "",

        applicantName: "",
        applicantPhone: "",
        applicantCompany: "",
        applicantCode: "",
        applicantType: "",

        fileList: [],
      },
      boardList: [
        "商业",
        "楼宇办公",
        "园区",
        "仓储",
        "厂房",
        "酒店",
        "住宅",
        "公寓",
        "工业",
        "农用",
        "市政配套",
        "场地",
        "其他",
      ],

      rules: {
        type: [{ required: true, message: "请选择权证类型" }],
        area: [{ required: true, message: "请输入面积" }],
        address: [{ required: true, message: "请输入权证地址" }],
      },

      fileColumns: [
        { title: "序号", dataIndex: "id", width: 80 },
        { title: "附件类型", dataIndex: "type" },
        {
          title: "附件信息",
          dataIndex: "file",
          scopedSlots: { customRender: "file" },
        },
        {
          title: "操作",
          dataIndex: "action",
          width: 80,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
};
</script>

<style scoped>
.detail-collapse {
  background: #fff;
}
.detail-collapse /deep/ .ant-collapse-header {
  font-size: 15px;
  font-weight: bold;
}
.detail-collapse /deep/ input.ant-input {
  height: 32px !important;
  border-radius: 4px;
}
::v-deep .detail-collapse .ant-form-item {
  margin-bottom: 4px !important;   /* 自己改 */
}

.title_icon {
  width: 6px;
  height: 22px;
  background: #007aff;
}
</style>
